import farmsClient from "../fieldDataClient";

export const fetchFarms = async (params = {}) => {
  const response = await farmsClient.get("/farms/", { params });
  return response.data;
};

export const fetchFarmById = async (farmId) => {
  const response = await farmsClient.get(`/farm/${farmId}/`);
  return response.data;
};

export const fetchLivestock = async (params = {}) => {
  const response = await farmsClient.get("/livestock/", { params });
  return response.data;
};

export const fetchLivestockById = async (livestockId) => {
  const response = await farmsClient.get(`/livestock/${livestockId}/`);
  return response.data;
};

export const fetchLivestockSurveys = async (params = {}) => {
  const response = await farmsClient.get("/livestock_surveys/", { params });
  return response.data;
};

export const fetchLivestockProcessingMethods = async (params = {}) => {
  const response = await farmsClient.get("/livestock_processing_methods/", {
    params,
  });
  return response.data;
};

export const fetchLivestockMeasurements = async (params = {}) => {
  const response = await farmsClient.get("/livestock_measurements/", {
    params,
  });
  return response.data;
};

export const fetchLivestockDigitalTwin = async (params = {}) => {
  const response = await farmsClient.get("/livestock_digital_twin/", {
    params,
  });
  return response.data;
};

export const fetchLivestockDigitalTwins = async (params = {}) => {
  const response = await farmsClient.get("/livestock_digital_twins/", {
    params,
  });
  return response.data;
};

const farmsApi = {
  fetchFarms,
  fetchFarmById,
  fetchLivestock,
  fetchLivestockById,
  fetchLivestockSurveys,
  fetchLivestockProcessingMethods,
  fetchLivestockMeasurements,
  fetchLivestockDigitalTwin,
  fetchLivestockDigitalTwins,
};

export default farmsApi;
